import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _createDiscountRequest = {};
var _createDiscountResponse = {};
var _getDiscountRequest = {};
var _getDiscountResponse = {};
var _listDiscountsRequest = { fieldMask: 'google.protobuf.FieldMask' };
var _listDiscountsResponse = {};
var _updateDiscountRequest = {};
var _updateDiscountResponse = {};
function resolveComWixpressRestaurantsCatalogsV3DiscountsApiUrl(opts) {
    var domainToMappings = {
        'www.wixapis.com': [
            {
                srcPath: '/restaurants/v3/catalogs',
                destPath: '/v3/catalogs',
            },
            {
                srcPath: '/restaurants/v3/catalog',
                destPath: '/v3/catalog',
            },
            {
                srcPath: '/restaurants/v3/draft-catalogs',
                destPath: '/v3/draft-catalogs',
            },
            {
                srcPath: '/restaurants/v3/catalogs_test',
                destPath: '/v3/catalogs',
            },
            {
                srcPath: '/_api/restaurants/v3/catalogs_test',
                destPath: '/v3/catalogs',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/restaurants/v3/catalogs',
                destPath: '/v3/catalogs',
            },
        ],
        'users._base_domain_': [
            {
                srcPath: '/_api/restaurants/v3/catalogs',
                destPath: '/v3/catalogs',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/restaurants/v3/catalogs',
                destPath: '/v3/catalogs',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/restaurants/v3/catalogs',
                destPath: '/v3/catalogs',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/restaurants/v3/catalogs',
                destPath: '/v3/catalogs',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/restaurants/v3/catalogs',
                destPath: '/v3/catalogs',
            },
            {
                srcPath: '/restaurants/v3/catalog',
                destPath: '/v3/catalog',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/restaurants/v3/catalogs',
                destPath: '/v3/catalogs',
            },
        ],
        _: [
            {
                srcPath: '/_api/restaurants/v3/catalogs',
                destPath: '/v3/catalogs',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/restaurants/v3/catalogs',
                destPath: '/v3/catalogs',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Retrieves a discount. */
export function getDiscount(payload) {
    var _a = serializer(_getDiscountRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getDiscountResponse, {}).fromJSON;
    function __getDiscount(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.catalogs.v3.discount',
            method: 'GET',
            methodFqn: 'com.wixpress.restaurants.catalogs.v3.DiscountsApi.GetDiscount',
            url: resolveComWixpressRestaurantsCatalogsV3DiscountsApiUrl({
                protoPath: '/v3/catalogs/{catalogId}/discounts/{discountId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getDiscount.fromReq = fromReq;
    __getDiscount.__isAmbassador = true;
    return __getDiscount;
}
/**
 * Updates a discount.
 * A discount can belong to a catalog, section, or dish. You can't create a discount that applies to a menu.
 */
export function updateDiscount(payload) {
    var _a = serializer(_updateDiscountRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateDiscountResponse, {}).fromJSON;
    function __updateDiscount(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.catalogs.v3.discount',
            method: 'PATCH',
            methodFqn: 'com.wixpress.restaurants.catalogs.v3.DiscountsApi.UpdateDiscount',
            url: resolveComWixpressRestaurantsCatalogsV3DiscountsApiUrl({
                protoPath: '/v3/catalogs/{catalogId}/discounts/{discount.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateDiscount.fromReq = fromReq;
    __updateDiscount.__isAmbassador = true;
    return __updateDiscount;
}
/**
 * Creates a discount.
 * You can create discounts for catalogs, sections, or dishes. You can't create a discount that applies to a menu.
 */
export function createDiscount(payload) {
    var _a = serializer(_createDiscountRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createDiscountResponse, {}).fromJSON;
    function __createDiscount(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.catalogs.v3.discount',
            method: 'POST',
            methodFqn: 'com.wixpress.restaurants.catalogs.v3.DiscountsApi.CreateDiscount',
            url: resolveComWixpressRestaurantsCatalogsV3DiscountsApiUrl({
                protoPath: '/v3/catalogs/{catalogId}/discounts',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createDiscount.fromReq = fromReq;
    __createDiscount.__isAmbassador = true;
    return __createDiscount;
}
/** Retrieves up to 1000 discounts. */
export function listDiscounts(payload) {
    var _a = serializer(_listDiscountsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listDiscountsResponse, {}).fromJSON;
    function __listDiscounts(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.catalogs.v3.discount',
            method: 'GET',
            methodFqn: 'com.wixpress.restaurants.catalogs.v3.DiscountsApi.ListDiscounts',
            url: resolveComWixpressRestaurantsCatalogsV3DiscountsApiUrl({
                protoPath: '/v3/catalogs/{catalogId}/discounts',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listDiscounts.fromReq = fromReq;
    __listDiscounts.__isAmbassador = true;
    return __listDiscounts;
}
//# sourceMappingURL=http.impl.js.map